class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
        this.CachedResults = {}
        this.Input = this.querySelector('input[type="search"]');
        this.DisplayTarget = this.querySelector('[data-display-target]')
        this.DefaultCollection = this.querySelector('[data-default-collection]')
    
        this.Input.addEventListener('input', this.onChange.bind(this));

        this.Input.hasAttribute('autofocusend') && this.FocusEnd()

        this.debouncedGetSearchResults = debounce(this.GetSearchResults.bind(this));
    }

    FocusEnd() {
        const length = this.Input.value.length
        this.Input.focus()
        this.Input.setSelectionRange(length, length)
    }
  
    onChange() {
        const searchTerm = this.Input.value.trim();
        if (!searchTerm.length) {
            return this.close();
        }
        this.CachedResults[searchTerm] ? this.DisplayCachedResult(searchTerm) : this.debouncedGetSearchResults(searchTerm);
    }
  
    GetSearchResults(searchTerm) {
        fetch(`/search/suggest?q=${searchTerm}&section_id=fam-predictive-search`)
        .then((response) => {
            if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
            }

            return response.text();
        })
        .then((text) => {
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-fam-predictive-search').innerHTML;
            if(!this.CachedResults[searchTerm] && resultsMarkup) {
                this.CachedResults[searchTerm] = resultsMarkup
            }
            this.DisplayTarget.innerHTML = resultsMarkup;
            InitializeGridCascades?.()
            InitializeAnimationElements?.()
            this.open();
        })
        .catch((error) => {
            this.close();
            console.log('SearchError:', error)
        })
    }

    DisplayCachedResult(searchTerm) {
        const resultsMarkup = this.CachedResults[searchTerm]
        this.DisplayTarget.innerHTML = resultsMarkup;
        InitializeGridCascades?.()
        InitializeAnimationElements?.()
        this.open()
    }

    // ShowDefaultCollection() {
    //     console.log(this.DefaultCollection)
    //     if (this.DefaultCollection) {
    //         this.DisplayTarget.innerHTML = this.DefaultCollection.childNodes
    //     }
    // }
  
    open() {
        this.DisplayTarget.dataset.state = 'Active'
        if(this.DefaultCollection) this.DefaultCollection.dataset.state = 'InActive';
    }
    
    close() {
        this.DisplayTarget.dataset.state = 'InActive'
        if(this.DefaultCollection) this.DefaultCollection.dataset.state = 'Active'; 
    }
}
  
customElements.define('predictive-search', PredictiveSearch);